import { get, has, findLast, uniqBy } from 'lodash';

export const getDataFromError = (err, errorCode) => {
  const error = findLast(err.graphQLErrors, { errorCode });
  return error ? error.data : {};
};

const errorAction = (type, error, meta) => {
  const res = {
    type,
    meta,
    error: true,
    payload: {
      error,
    },
  };

  if (has(error, 'graphQLErrors')) {
    const apiErrorCodes = error.graphQLErrors.map(err => get(err, 'extensions.code'), 500).map(Number);

    res.payload.apiErrorCodes = apiErrorCodes.length > 0 ? uniqBy(apiErrorCodes) : [503];

    console.log('apiErrorCodes:', res.payload.apiErrorCodes);
  }

  // todo: add liveswitch errors section

  return res;
};

export default errorAction;
